/* istanbul ignore file */
import React from 'react'
import Select from 'react-select'
import Selector from './Selector'

export default (props) => <Selector selectorComponent={Select} {...props} />
